import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import Loader from "../Loader/Loader";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import TopUpReqModal from "./TopUpReqModal";
import TopUpWalletModal from "../topuprequest/TopUpWalletModal";
import TopUpRCSModal from "../topuprequest/TopUpRCSModal";
import MainWalletFilterModal from "./MainWalletFilterModal";

const defaultFilterData = {
  actionType: "",
  minTxnAmount: "",
  maxTxnAmount: "",
  fromDate: "",
  toDate: "",
};

const MainWalletActivity = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showWalletModal, setShowWalletModal] = useState(false); // State for Wallet modal
  const [showRCSModal, setShowRCSModal] = useState(false); // State for RCS modal
  const [editData, setEditData] = useState({});
  const [walletHistoryData, setWalletHistoryData] = useState([]);
  const [custData, setCustData] = useState("");
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [utrNo, setutrNo] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [smsBalance, setsmsBalance] = useState("");

  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const openModalFilter = () => {
    setIsFilterModalOpen(true);
  };

  const closeModalFilter = () => {
    setIsFilterModalOpen(false);
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
    setCurrentPage(1);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    // setFilterData(defaultFilterData);
    fetchCust(1);
    // fetchCusWalletHistoryData(1, filterData);
  }, []);

  const fetchCust = () => {
    const requestBody = {
      username: loggedInUserName,
      // status: "1",
    };

    axiosPostApi(apiList.FETCH_CUSTOMER_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.data) {
          const customerCode = response?.data?.data[0]?.customerCode;
          if (customerCode) {
            fetchCusWalletHistoryData(1, filterData);
          }
          setCustData(response?.data?.data[0]);
        }
      })
      .catch((error) => {
        console.error("Error fetching retailer data:", error);
      });
  };

  const fetchCusWalletHistoryData = async (pageNo, filters) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        actionType: filters.actionType,
        minTxnAmount: filters.minTxnAmount,
        maxTxnAmount: filters.maxTxnAmount,
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.Fetch_CusWallet_History}?&pageSize=${pageSize}&pageNo=${pageNo}`,
        requestBody
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setWalletHistoryData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setWalletHistoryData([]);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setWalletHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      transactionDate: item.transactionDate?.split(" ")?.[0],
      id: index + 1,
    }));
  };

  const topUpReqHeaders = [
    "Customer Code",
    "Old Main Wallet Balance (₹)",
    "New Main Wallet Balance (₹)",
    "Txn Amount (₹)",
    "GST Amount (₹)",
    "Total Amount (₹)",
    "Transaction Date",
    "Action Type",
    "Reference Id",
    "Remark",
    "Old Sms Count(Qty)",
    "New Sms Count(Qty)",
    "Sms Rate",
    "Rcs Rate",
    "Old Rcs Count(Qty)",
    "New Rcs Count(Qty)",
  ];

  const topUpReqHeaderToKeyMap = {
    "Customer Code": "customerCode",
    "Old Main Wallet Balance (₹)": "oldMainBalance",
    "New Main Wallet Balance (₹)": "newMainBalance",
    "Txn Amount (₹)": "txnAmount",
    "GST Amount (₹)": "gstAmount",
    "Total Amount (₹)": "totalAmount",
    "Transaction Date": "txnDate",
    "Action Type": "actionType",
    "Reference Id": "referenceId",
    Remark: "remarks",
    "Old Sms Count(Qty)": "oldSmsCount",
    "New Sms Count(Qty)": "newSmsCount",
    "Sms Rate": "rate",
    "Rcs Rate": "rcsRate",
    "Old Rcs Count(Qty)": "oldRcsCount",
    "New Rcs Count(Qty)": "newRcsCount",
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
  };

  const handleCloseWalletModal = () => {
    setShowWalletModal(false);
  };

  const handleCloseRCSModal = () => {
    setShowRCSModal(false);
  };

  const handlerTopUpReqSMS = (id, actionType = "view") => {
    setModalAction(actionType);

    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else if (actionType === "delete") {
      setutrNo(id.utrNo);
      setCustomerName(id.customerName);
      setCustomerCode(id.customerCode);
      setsmsBalance(id.oldSmsBalance);
      setShowModal(true);
    } else if (actionType === "auth") {
      setutrNo(id.utrNo);
      setCustomerName(id.customerName);
      setCustomerCode(id.customerCode);
      setsmsBalance(id.oldSmsBalance);
      setShowModal(true);
    } else if (actionType === "view") {
      let data = walletHistoryData?.find((item) => item.id === id?.id);
      if (data) {
        setEditData(data);
        setShowModal(true);
      }
    } else if (actionType === "wallet") {
      setShowWalletModal(true);
    } else if (actionType === "rcs") {
      setShowRCSModal(true);
    }
  };

  const handleFinalAuthorization = (authData) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to accept this top-up request?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#00b6ce",
      cancelButtonColor: "#e74c3c",
      confirmButtonText: "Yes, accept it!",
      cancelButtonText: "No, cancel!",
      customClass: {
        confirmButton: "swal-confirm-button",
        cancelButton: "swal-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const requestBody = {
          ...authData,
          username: loggedInUserName,
          status: "1",
        };

        axiosPostApi(apiList.AUTH_BLOCK_TOPUP_REQ, requestBody)
          .then((response) => {
            if (response?.status === 200 && response?.data?.respCode === "00") {
              toast.success("Top-up request accepted successfully!");
              fetchCusWalletHistoryData(1);
            } else {
              CustomAlert({
                title: "Failed to Accept Request",
                text:
                  response.data?.message ||
                  "Invalid credentials. Please try again!",
                icon: "error",
                confirmButtonText: "Retry",
              });
            }
          })
          .catch((error) => {
            console.error("Error Authorizing request", error);
            toast.error("Failed to Authorize request.");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        toast.info("Authorization request canceled.");
      }
    });
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {
        loading ? (
          <Loader />
        ) : (
          // ) : (
          <>
            <MasterTable
              headers={topUpReqHeaders}
              data={walletHistoryData}
              handleAction={handlerTopUpReqSMS}
              filterFields={["customerCode", "actionType"]}
              entityType="Top-up SMS Request"
              headerToKeyMap={topUpReqHeaderToKeyMap}
              loading={loading}
              handleAuth={handleFinalAuthorization}
              pageDetails={pageDetails}
              noData={noData}
              currentPage={currentPage}
              pageSize={pageSizeCount}
              totalRecord={totalRecord}
              fetchNextData={(pageNo) =>
                fetchCusWalletHistoryData(pageNo, filterData)
              }
              setCurrentPage={setCurrentPage}
              hideAction="hideAction"
              filterData={filterData}
              fetchData={() => {
                fetchCusWalletHistoryData(1, defaultFilterData);
              }}
              handleReset={handleReset}
              openModalFilter={openModalFilter}
            />
            {isFilterModalOpen && (
              <MainWalletFilterModal
                show={isFilterModalOpen}
                handleClose={closeModalFilter}
                setFilterData={setFilterData}
                filterData={filterData}
                handleReset={handleReset}
                setWalletHistoryData={setWalletHistoryData}
                setPageDetails={setPageDetails}
                currentPage={currentPage}
                setNoData={setNoData}
                pageSize={pageSizeCount}
              />
            )}
            <TopUpReqModal
              show={showModal}
              handleClose={handleCloseModal}
              editData={editData}
              action={modalAction}
              data={walletHistoryData}
              customerData={custData}
              utrNo={utrNo}
              customerName={customerName}
              customerCode={customerCode}
              smsBalance={smsBalance}
            />

            <TopUpWalletModal
              show={showWalletModal}
              handleClose={handleCloseWalletModal}
              customerData={custData}
              fetchData={fetchCusWalletHistoryData}
            />
            <TopUpRCSModal
              show={showRCSModal}
              handleClose={handleCloseRCSModal}
              customerData={custData}
              fetchData={fetchCusWalletHistoryData}
            />
          </>
        )
        // )}
      }
    </div>
  );
};

export default MainWalletActivity;